import Layout from '../shared/Layout'

const Home = () => {
    return (
        <Layout>
            <h4 className='home-heading'>Welcome to the To-Do List App</h4>

        </Layout>
    )
}

export default Home




